export default "https://cdn-static.gokick.com/assets/09fae944e838c54f14fd77486c4f90b3472cb396/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";